import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\RiderProjects\\pdcweb\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { DecPwd } from "../../utils/helper";
import { SignIn, RefreshToken, GetNonce } from "../../api/Auth";
import CryptoJS from 'crypto-js';
export default {
  data: function data() {
    return {
      param: {
        username: '',
        password: ''
      },
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    submitForm: function () {
      var _submitForm = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var data, key, hmac, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return GetNonce(this.param.username);

              case 2:
                data = _context.sent;
                // 2) 把 nonce 转成 CryptoJS 的 WordArray
                key = CryptoJS.enc.Utf8.parse(data.data.nonce); // 3) HMAC-SHA256

                hmac = CryptoJS.HmacSHA256(this.param.password, key).toString(CryptoJS.enc.Hex); // 3) 提交登录：loginid, salt, pwd（即 hmac）
                // 4) 正常提交

                _context.next = 7;
                return SignIn({
                  loginid: this.param.username,
                  nonce: data.data.nonce,
                  expiry: data.data.expiry,
                  signature: data.data.signature,
                  response: hmac
                });

              case 7:
                res = _context.sent;
                console.log(res.data);

                if (res.status === 0) {
                  this.$message.success('登录成功');
                  localStorage.setItem('ms_username', this.param.username);
                  localStorage.setItem('ms_userInfo', JSON.stringify(res.data));
                  localStorage.setItem('token', res.msg);
                  this.$router.push('/');
                } else {
                  this.$message.error(res.msg);
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submitForm() {
        return _submitForm.apply(this, arguments);
      }

      return submitForm;
    }(),
    updateToken: function () {
      var _updateToken = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var resRefresh;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return RefreshToken();

              case 2:
                resRefresh = _context2.sent;

                if (resRefresh.status === 0) {
                  localStorage.setItem('token', resRefresh.msg);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function updateToken() {
        return _updateToken.apply(this, arguments);
      }

      return updateToken;
    }()
  }
};